import { Heading, HFlow, Icon, Tooltip, VFlow } from 'bold-ui'
import { resolveName } from 'components/form/final-form/useField'
import { IdentidadeGeneroEnum, SexoEnum } from 'graphql/types.generated'
import React from 'react'
import { FieldArray, FieldArrayRenderProps } from 'react-final-form-arrays'
import { MetaPath } from 'util/metaPath'

import { ResultadoExameSemSolicitacaoModel, ResultadosExamesNaoSolicitadosModel } from '../../model'
import { ExamesSelect } from '../components/ExamesSelect'
import { ResultadoExameSemSolicitacaoField } from './ResultadoExameSemSolicitacaoField'

interface ExamesSemSolicitacaoFieldProps {
  name: MetaPath<ResultadosExamesNaoSolicitadosModel>
  cidadaoSexo: SexoEnum
  cidadaoIdentidadeGeneroDbEnum: IdentidadeGeneroEnum
  cidadaoDataNascimento: LocalDate
}

export const ExamesSemSolicitacaoField = (props: ExamesSemSolicitacaoFieldProps) => {
  const { name, cidadaoSexo, cidadaoIdentidadeGeneroDbEnum, cidadaoDataNascimento } = props

  return (
    <VFlow vSpacing={0.25}>
      <HFlow hSpacing={0.25} alignItems='center'>
        <Heading level={5}>Adicionar exame sem solicitação</Heading>

        <Tooltip text='Insira exames NÃO solicitados nesta instalação do e-SUS APS PEC'>
          <Icon icon='infoCircleFilled' fill='primary' size={1} />
        </Tooltip>
      </HFlow>

      <FieldArray<ResultadoExameSemSolicitacaoModel>
        name={resolveName(name)}
        render={(fieldArrayRenderProps: FieldArrayRenderProps<ResultadoExameSemSolicitacaoModel, any>) => {
          const {
            fields: { unshift, value, remove },
          } = fieldArrayRenderProps

          return (
            <VFlow>
              <ExamesSelect
                sexo={cidadaoSexo}
                identidadeGeneroDbEnum={cidadaoIdentidadeGeneroDbEnum}
                dataNascimento={cidadaoDataNascimento}
                onChange={(item) => unshift({ exame: item })}
              />

              {value?.map((item, index) => (
                <ResultadoExameSemSolicitacaoField
                  key={index}
                  name={name[index]}
                  exame={item.exame}
                  onRemove={() => remove(index)}
                />
              ))}
            </VFlow>
          )
        }}
      />
    </VFlow>
  )
}
